import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Header } from 'semantic-ui-react';
import server from '../../functions/server';
import userId from '../../functions/userid';
import $ from 'jquery';

export default class EditCity extends React.Component {
  state = {
    open: false,
    city: ""
  };

  handleClose = () => {
    this.props.handleState({editcity: false});
  };

  handleUpdate = () => {
    let city = this.state.city.trim();
    if (city.length < 2) {
      this.setState({
        message: "Invalid city"
      });
      return;
    }
    let data = {
      id: this.props.id,
      owner: userId(),
      type: 'city',
      value: city
    }
    console.log(data);
    let context = this;
    $.ajax({
      type: 'POST',
      url: server() + "/shop/update.php",
      data: data,
      beforeSend: function(x) {
          context.setState({
            dimmer: true,
            loadText: "Updating Mobile Number"
          });
      },
      success: function(data, status) {
        let editcity = true;
        if (data == "1") {
          context.props.updateProps('city', city);
          editcity = false;
        }
        context.props.handleState({
          dimmer: false,
          loadText: "", editcity

        });
      },
      error: function(data, status) {
        context.props.handleState({
          dimmer: false,
          loadText: "",
          message: data
        });
      }
    });
  }

  render() {
    if (!this.state.city) {
      this.setState({
        city: this.props.city
      })
    }
    return (
      <div>
        <Dialog
          open={this.props.open}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">Update City</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Enter the city
            </DialogContentText>
            <TextField
              autoFocus
              margin="dense"
              id="descriptionText"
              value={this.state.city}
              onChange={(e) => {this.setState({city: e.target.value, message:""})}}
              fullWidth
            />
            <Header as='h4' color='red'>
              {this.state.message}
            </Header>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={this.handleUpdate} color="primary">
              Update
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
